// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "row-1LpPC";
var _4 = "buttons_row-3RAMV";
var _5 = "mobile_price_row-1tAoC";
var _6 = "root-3_Yh-";
var _7 = "cancel_btn-1Z5Ku";
var _8 = "confirm_btn-1vw9o";
export { _1 as "__esModule", _2 as "mobile", _3 as "row", _4 as "buttons_row", _5 as "mobile_price_row", _6 as "root", _7 as "cancel_btn", _8 as "confirm_btn" }
export default { "__esModule": _1, "mobile": _2, "row": _3, "buttons_row": _4, "mobile_price_row": _5, "root": _6, "cancel_btn": _7, "confirm_btn": _8 }
